// @ts-strict-ignore
import sw from '../utils/switch'
import * as act from '../redux/app-actions'

export default (state = {}, { type, payload }) =>
  sw({
    [act.SET_ENV]: (env: any) => ({ env, ...state }),
    [act.SET_THEME]: (theme: any) => ({ ...state, theme }),
    [act.SET_META_INFO]: (meta: any) => ({ meta, ...state }),
    [act.SET_ROUTER]: (router: any) => ({ router, ...state }),
    [act.SET_LOCATION]: (location: any) => ({ ...state, location }),
    [act.SET_TRUSTPILOT]: (trustpilot: any) => ({ ...state, trustpilot }),
    default: state,
  })(type, payload)
